/*
 * @Author: your name
 * @Date: 2022-03-08 08:50:12
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-16 14:11:04
 * @Description: file conten
 */
import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import app from "./modules/app";
import options from "./modules/options";
import settle from "./modules/settle";
import permission from "./modules/permission";
import sms from "./modules/sms";
import user from "./modules/user";
import sharePoster from "./modules/sharePoster";
import shareGoods from "./modules/shareGoods";
import piecemeal from "./modules/piecemeal";
import lottery from "./modules/lotterytable";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    options,
    settle,
    permission,
    sms,
    user,
    sharePoster,
    shareGoods,
    piecemeal,
    lottery
  },
  getters,
});
export default store;